import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react';
import { CloudResourcesStatisticsApi } from './CloudResourcesStatisticsApi';

export class CloudResourcesStatisticsApiClient
  extends DefaultApiClient
  implements CloudResourcesStatisticsApi
{
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'catalog',
      ...options,
    });
  }

  async getAccountCloudResourcesStatistics(
    accountId: string,
  ): Promise<DefaultApiResponse> {
    const urlSegment = `v2/account/${encodeURIComponent(
      accountId,
    )}/cloud-resources/statistics`;
    return await this.get(urlSegment);
  }
}
